import * as React from 'react'

/**
 * Icon for printer
 */
export const IconPrinter = (): JSX.Element => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2C16.1046 2 17 2.89543 17 4V7H18C19.1046 7 20 7.89543 20 9V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H7V4C7 2.89543 7.89543 2 9 2H15ZM17 8.90918C16.448 8.90943 16.0001 9.35714 16 9.90918C16 10.4613 16.4479 10.9089 17 10.9092C17.5521 10.9089 18 10.4613 18 9.90918C17.9999 9.35715 17.552 8.90944 17 8.90918ZM9.99902 4C9.44724 4.00051 8.99913 4.44812 8.99902 5V7H15V5C14.9999 4.44797 14.552 4.00026 14 4H9.99902Z"
        fill="white"
      />
    </svg>
  )
}
